import React from "react";
import styles from "./ReferenPriceTest.module.css";

const ReferenPriceTest = () => {
  return (
    <div className={styles.container}>
      <div>
        <h2
          style={{
            textAlign: "center",
            fontSize: "2.2rem",
            fontWeight: 700,
            color: "#19213e",
            marginBottom: "36px",
            lineHeight: 1.2,
          }}
        >
          Payout Structure That Works for You
        </h2>
        <p className={styles.description}>
          Know what you earn every time by promoting the PrepAI assessment
          platform and solutions.
        </p>
      </div>
      <div className={styles.commissionRates}>
        <div className={styles.header}>
          <span className={styles.emoji}>💰</span>
          <h2>Standard Commission Rates</h2>
        </div>

        <div className={styles.cardList}>
          <div className={styles.cardHeader}>
            <div>
              <b>
                No. of Licenses Sold
                <br />
                (Lifetime / Subscriptions)
              </b>
            </div>
            <div>
              <b>
                Commission <br />
                (On generated revenue)
              </b>
            </div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>1-10</div>
            </div>
            <div className={styles.cardRight}>10%</div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>11-20</div>
            </div>
            <div className={styles.cardRight}>12%</div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>21-30</div>
            </div>
            <div className={styles.cardRight}>15%</div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>30+</div>
            </div>
            <div className={styles.cardRight}>20%</div>
          </div>
        </div>
        {/* <p className={styles.footnote}>Commission (On generated revenue)</p> */}
      </div>
      <div className={styles.bonusSection}>
        <div className={styles.header}>
          <span className={styles.lightning}>⚡</span>
          <h2>Fast Start Bonus Program (First 30 Days)</h2>
        </div>
        <p className={styles.subtitle}>
          Boost your earnings in your first 30 days as a PrepAI affiliate!
        </p>
        <p className={styles.description}>
          Refer paying customers within your first month and earn extra cash —
          on top of your standard commission rates mentioned above.
        </p>

        <div className={styles.cardList}>
          <div className={styles.cardHeader}>
            <div>
              <b>Paid Referrals in First 30 Days</b>
            </div>
            <div>
              <b>Bonus Amount</b>
            </div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>3-5 users</div>
            </div>
            <div className={styles.cardRight}>$75</div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>6-10 users</div>
            </div>
            <div className={styles.cardRight}>$150</div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>10+ users</div>
            </div>
            <div className={styles.cardRight}>$300</div>
          </div>
        </div>
        <p className={styles.footnote}>
          💡 One-time bonus based on total paid referrals made within 30 days of
          signup. Automatically added to your payout.
        </p>
      </div>
      {/* Monthly Referral Bonus Section */}
      <div className={styles.monthlySection}>
        <div className={styles.header}>
          <span className={styles.emoji}>🗓️</span>
          <h2>Monthly Referral Bonus</h2>
        </div>
        <p className={styles.subtitle}>
          Earn extra every month based on paid referrals — no limits, resets
          every month.
        </p>
        <div className={styles.cardList}>
          <div className={styles.cardHeader}>
            <div>
              <b>Paid Referrals in a Month</b>
            </div>
            <div>
              <b>Bonus Amount</b>
            </div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>5–9 users</div>
            </div>
            <div className={styles.cardRight}>$100</div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>10–20 users</div>
            </div>
            <div className={styles.cardRight}>$200</div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardLeft}>
              <div>20+ users</div>
            </div>
            <div className={styles.cardRight}>$400</div>
          </div>
        </div>
      </div>
      {/* Summary Section */}
      <div className={styles.summarySection}>
        <div className={styles.header}>
          <span className={styles.emoji}>🏁</span>
          <h2>Summary (What You Can Earn)</h2>
        </div>
        <ul className={styles.summaryList}>
          <li>
            <b>Standard Commission Rates on Every Referral</b>
          </li>
          <li>
            <span className={styles.emoji}>💥</span>{" "}
            <b> First 30 Days = Standard Commission Rates + Fast Start Bonus</b>
          </li>
          <li>
            <span className={styles.emoji}>🔁</span>{" "}
            <b>
              Every Month = Standard Commision Rates + Monthly Referral Bonus
            </b>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ReferenPriceTest;
